var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data !== null
    ? _c(
        "div",
        [
          _c("Top"),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm" }),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _vm.currentChild && _vm.currentChild.below13
                  ? _c("div", { staticClass: "card--wrapper" }, [
                      _c("div", { staticClass: "card" }, [
                        _c(
                          "h4",
                          { staticClass: "text-primary-fh left-header" },
                          [
                            _vm._v(
                              "\n              Samtycke för " +
                                _vm._s(
                                  _vm.currentChild.firstName +
                                    " " +
                                    _vm.currentChild.lastName
                                ) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.data.welcomepage.consentScreeningCaregiver
                            )
                          }
                        }),
                        _vm._v(" "),
                        _vm.isIndexPatient
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-lg btn-block",
                                class:
                                  _vm.currentChild.consentScreening === true
                                    ? "consent-choice"
                                    : "",
                                on: {
                                  click: function($event) {
                                    return _vm.indexPatientConsentScreening(
                                      (_vm.consentScreening = true)
                                    )
                                  }
                                }
                              },
                              [_vm._v("Ja")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isSecondaryCaregiver
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-lg btn-block",
                                class:
                                  _vm.currentChild.consentScreening === true
                                    ? "consent-choice"
                                    : "",
                                on: {
                                  click: function($event) {
                                    return _vm.secondaryCaregiverConsentScreening(
                                      (_vm.consentScreening = true)
                                    )
                                  }
                                }
                              },
                              [_vm._v("Ja")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix--min" }),
                        _vm._v(" "),
                        _vm.isIndexPatient
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-lg btn-block",
                                class:
                                  _vm.currentChild.consentScreening === false
                                    ? "consent-choice"
                                    : "",
                                on: {
                                  click: function($event) {
                                    return _vm.indexPatientConsentScreening(
                                      (_vm.consentScreening = false)
                                    )
                                  }
                                }
                              },
                              [_vm._v("Nej")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isSecondaryCaregiver
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-lg btn-block",
                                class:
                                  _vm.currentChild.consentScreening === false
                                    ? "consent-choice"
                                    : "",
                                on: {
                                  click: function($event) {
                                    return _vm.secondaryCaregiverConsentScreening(
                                      (_vm.consentScreening = false)
                                    )
                                  }
                                }
                              },
                              [_vm._v("Nej")]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix--min" }),
                      _vm._v(" "),
                      _vm.consentScreening
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "alert alert-success alert-consent-screening"
                            },
                            [
                              _c("strong", [
                                _vm._v(
                                  "\n              Du har nu gett samtycke för screening gällande " +
                                    _vm._s(
                                      _vm.currentChild.firstName +
                                        " " +
                                        _vm.currentChild.lastName
                                    ) +
                                    ".\n            "
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.consentScreening
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "alert alert-warning alert-consent-screening"
                            },
                            [
                              _c("strong", [
                                _vm._v("\n              Du har valt att "),
                                _c("i", [_vm._v("inte")]),
                                _vm._v(
                                  " ge samtycke för screening gällande " +
                                    _vm._s(
                                      _vm.currentChild.firstName +
                                        " " +
                                        _vm.currentChild.lastName
                                    ) +
                                    ".\n            "
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentChild
                  ? _c("div", { staticClass: "card--wrapper" }, [
                      _c("div", { staticClass: "card" }, [
                        _c(
                          "h4",
                          { staticClass: "text-primary-fh left-header" },
                          [
                            _vm._v(
                              "\n              Samtycke för " +
                                _vm._s(
                                  _vm.currentChild.firstName +
                                    " " +
                                    _vm.currentChild.lastName
                                ) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.data.welcomepage.consentResearchCaregiver
                            )
                          }
                        }),
                        _vm._v(" "),
                        _vm.isIndexPatient
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-lg btn-block",
                                class:
                                  _vm.currentChild.consentResearch === true
                                    ? "consent-choice"
                                    : "",
                                on: {
                                  click: function($event) {
                                    return _vm.indexPatientConsentResearch(
                                      (_vm.consentResearch = true)
                                    )
                                  }
                                }
                              },
                              [_vm._v("Ja")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isSecondaryCaregiver
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-lg btn-block",
                                class:
                                  _vm.currentChild.consentResearch === true
                                    ? "consent-choice"
                                    : "",
                                on: {
                                  click: function($event) {
                                    return _vm.secondaryCaregiverConsentResearch(
                                      (_vm.consentResearch = true)
                                    )
                                  }
                                }
                              },
                              [_vm._v("Ja")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix--min" }),
                        _vm._v(" "),
                        _vm.isIndexPatient
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-lg btn-block",
                                class:
                                  _vm.currentChild.consentResearch === false
                                    ? "consent-choice"
                                    : "",
                                on: {
                                  click: function($event) {
                                    return _vm.indexPatientConsentResearch(
                                      (_vm.consentResearch = false)
                                    )
                                  }
                                }
                              },
                              [_vm._v("Nej")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isSecondaryCaregiver
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-lg btn-block",
                                class:
                                  _vm.currentChild.consentResearch === false
                                    ? "consent-choice"
                                    : "",
                                on: {
                                  click: function($event) {
                                    return _vm.secondaryCaregiverConsentResearch(
                                      (_vm.consentResearch = false)
                                    )
                                  }
                                }
                              },
                              [_vm._v("Nej")]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix--min" }),
                      _vm._v(" "),
                      _vm.consentResearch
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "alert alert-success alert-consent-research"
                            },
                            [
                              _c("strong", [
                                _vm._v(
                                  "\n              Du har nu gett samtycke för forskning gällande " +
                                    _vm._s(
                                      _vm.currentChild.firstName +
                                        " " +
                                        _vm.currentChild.lastName
                                    ) +
                                    ".\n            "
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.consentResearch
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "alert alert-warning alert-consent-research"
                            },
                            [
                              _c("strong", [
                                _vm._v("\n              Du har valt att "),
                                _c("i", [_vm._v("inte")]),
                                _vm._v(
                                  " ge samtycke för forskning gällande " +
                                    _vm._s(
                                      _vm.currentChild.firstName +
                                        " " +
                                        _vm.currentChild.lastName
                                    ) +
                                    ".\n            "
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-dark btn-lg btn-block",
                    on: {
                      click: function($event) {
                        return _vm.goToWelcomeRoute()
                      }
                    }
                  },
                  [_vm._v("\n          ← Tillbaka\n        ")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm" })
            ])
          ]),
          _vm._v(" "),
          _c("Bottom")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22bcf66b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22bcf66b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConsentMinor.vue
// module id = null
// module chunks = 